<template lang="pug">
.crud
  modal-sending-receptions(:sending_id='sending_id')
  .container-fluid
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between")
      vm-col.card__wrapper(vm-align="center" vm-type="flex" vm-justify="center" vm-sm=12 vm-md=4 vm-lg=3)
        vm-row(vm-align="center" vm-type="flex" vm-justify="center")
          vm-col.title__wrapper(vm-align="center" vm-type="flex" vm-justify="center" vm-w="12")
            h4.title Folio (VENTA):
          vm-col.information__wrapper(vm-align="center" vm-type="flex" vm-justify="center" vm-w="12")
            h3.information # {{ sale.folio }}
      vm-col.card__wrapper(vm-align="center" vm-type="flex" vm-justify="center" vm-sm=12 vm-md=4 vm-lg=3)
        vm-row(vm-align="center" vm-type="flex" vm-justify="center")
          vm-col.title__wrapper(vm-align="center" vm-type="flex" vm-justify="center" vm-w="12")
            h4.title Cliente:
          vm-col.information__wrapper(vm-align="center" vm-type="flex" vm-justify="center" vm-w="12")
            h3.information {{ sale.customer.tradename }}
      vm-col.card__wrapper(vm-align="center" vm-type="flex" vm-justify="center" vm-sm=12 vm-md=4 vm-lg=3)
        vm-row(vm-align="center" vm-type="flex" vm-justify="center")
          vm-col.title__wrapper(vm-align="center" vm-type="flex" vm-justify="center" vm-w="12")
            h4.title Creado Por:
          vm-col.information__wrapper(vm-align="center" vm-type="flex" vm-justify="center" vm-w="12")
            h3.information {{ sale.created_by.name }}
    vm-tabs
      vm-tab(vm-label='Registrar Nuevo Envio a cliente')
        vm-col.card(vm-sm=12)
          vm-row(vm-align="center" vm-type="flex" vm-justify="center" vm-w="12")
            vm-col(vm-justify="center", vm-align="center", vm-w=4 class="gutters")
              b-form-group
                vm-input(autofocus :placeholder='$t("sending_receptions.parcel")' :danger="!$v.form.parcel" :danger-text="'parcel is required'" v-model="form.parcel" :label='$t("sending_receptions.parcel")')
            vm-col(vm-justify="center", vm-align="center", vm-w=4 class="gutters")
              b-form-group
                vm-input(autofocus :placeholder='$t("sending_receptions.guide_number")' :danger="!$v.form.guide_number" :danger-text="'guide_number is required'" v-model="form.guide_number" :label='$t("sending_receptions.guide_number")')
            vm-col(vm-justify="center", vm-align="center", vm-w=4 class="gutters")
              b-form-group
                vm-input(autofocus :placeholder='$t("sending_receptions.amount")' :danger="!$v.form.amount" :warning="!direct_shipping" warning-text="Ingresa un monto mayor a 0" :danger-text="'amount is required'" v-model="form.amount" :label='$t("sending_receptions.amount")' type="float")
            vm-col(vm-sm=12)
              vm-table(max-height="500px" :data="receptions")
                template(slot="header")
                  .d-flex.justify-content-between
                template(slot="thead")
                  vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('sending_receptions.' + column) }}
                template(slot-scope="{data}")
                  vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                    vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                      .row
                        slot(v-if="column == 'purchase_order'") {{data[indextr][column]['folio']}}
                        slot(v-if="column == 'product'") {{data[indextr][column]['name']}}
                        slot(v-if="column == 'quantity_ordered'") {{parseFloat(data[indextr][column])}} / {{parseFloat(data[indextr]['total_received_quantity'])}} / {{ parseFloat(data[indextr]['limit_quantity_to_be_sent']) }}
                        .input__wrapper(v-if="column == 'quantity_to_send'")
                          vm-input(class="mx-auto" :disabled="parseFloat(data[indextr]['total_received_quantity']) === parseFloat(data[indextr]['limit_quantity_to_be_sent'])"  autofocus v-model="data[indextr][column]" @blur="checkValue(data[indextr])" @keyup="checkValue(data[indextr])" @keypress="checkValue(data[indextr])" style="width:100px;")
            vm-row(vm-align="center" vm-type="flex" vm-justify="center" vm-w="12")
              vm-button(icon="checkmark-circle-2-outline" @click="saveRecords(false)" :disabled="$v.form.$invalid || touched") Enviar
              vm-button(icon="checkmark-circle-2-outline" @click="saveRecords(true)" :disabled="$v.form.$invalid" class="ml-2" v-if="is_received") Enviar Todo
    vm-tabs
      vm-tab(vm-label='Envios a cliente realizados')
        vm-col.card(vm-sm=12)
          vm-table(max-height="500px" :data="sendings")
            template(slot="header")
              .d-flex.justify-content-between
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columnsSendings") {{ $t('sending_receptions.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columnsSendings")
                  .row
                    slot(v-if="column == 'parcel'") {{data[indextr][column]}}
                    slot(v-if="column == 'guide_number'") {{data[indextr][column]}}
                    slot(v-if="column == 'amount'") {{data[indextr][column] | currency }}
                    slot(v-if="column == 'shipping_date'") {{data[indextr][column] | moment('DD MMMM YYYY')}}
                    slot(v-if="column == 'created_by'") {{data[indextr]['user'].name}}
                    slot(v-if="column == 'actions' && $auth.check('Admin')")
                      .actions__wrapper
                        vm-button(type="flat" icon="eye-outline" color="#026481" @click="showSendingReceptions(data[indextr])")
                        vm-button(type="flat" icon="trash-2-outline" color="rgb(242, 19, 93)" @click="deleteSendinReceptions(data[indextr], tr)")
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { required, minLength } from 'vuelidate/lib/validators'
import ModalSendingReceptions from '@/components/modals/ModalSendingReceptions.vue'
const { mapGetters, mapActions } = createNamespacedHelpers('SendingReceptionInformation')
export default {
  name: 'SendingReceptions',
  components: {
    ModalSendingReceptions
  },
  data: () => ({
    form: {},
    columns: [
      'purchase_order',
      'product',
      'quantity_ordered',
      'quantity_to_send'
    ],
    columnsSendings: [
      'parcel',
      'guide_number',
      'amount',
      'shipping_date',
      'created_by',
      'actions'
    ],
    sending_id: '',
    sending: '',
    touched: true,
    disabled: false
  }),
  validations: {
    form: {
      parcel: {
        required,
        minLength: minLength(2)
      },
      guide_number: {
        required,
        minLength: minLength(2)
      },
      amount: {
        required
      }
    }
  },
  computed: {
    ...mapGetters([
      'receptions',
      'sale',
      'isModalVisible',
      'sendings'
    ]),
    is_received () {
      return parseFloat(this.sale.total_quantity_ordered) === parseFloat(this.sale.total_quantity_received)
    },
    direct_shipping () {
      return this.sale.purchase_orders[0].supplier.direct_shipping
    }
  },
  watch: {
    receptions (receptions) {
      let check = 0

      receptions.map((reception) => {
        check += parseFloat(reception.limit_quantity_to_be_sent)
      })

      if (check === this.total_quantity_received) this.touched = true
      this.sale.total_quantity_received === this.sale.total_quantity_ordered ? this.disabled = false : this.disabled = true
    }
  },
  async created () {
    await this.loadSale({ sale_id: this.$route.params.id }).then(() => {
      this.loadRecords({ sale_id: this.sale.id }).then(() => {
        this.loadCustomerSendings({ sale_id: this.sale.id })
      })
    })
  },
  methods: {
    ...mapActions([
      'deleteSendingDetail',
      'setModalVisible',
      'loadSale',
      'loadRecords',
      'addRecord',
      'loadCustomerSendings'
    ]),
    showSendingReceptions (data) {
      this.sending_id = data.id
      this.setModalVisible(true)
    },
    async saveRecords (all = false) {
      if (all) {
        this.receptions.map((reception) => {
          reception.quantity_to_send = (parseFloat(reception.total_received_quantity) - parseFloat(reception.limit_quantity_to_be_sent))
        })
      }
      this.form.created_by = this.$auth.user().id
      this.form.sale_id = this.$route.params.id
      this.form.details_to_sent = this.receptions

      await this.addRecord({ sale_id: this.$route.params.id, data: this.form }).then(() => {
        this.loadRecords({ sale_id: this.sale.id }).then(() => {
          this.form = {}
        })
      })
    },
    async deleteSendinReceptions (detail) {
      let t = this
      this.auxSendingDetail = () => {
        t.deleteSendingDetail({ sale_id: this.$route.params.id, sending_reception: detail.id, data: detail }).then(() => {
          this.loadRecords({ sale_id: this.sale.id })
        })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.sending_detail'), attribute: this.$t(detail.id) }),
        accept: this.auxSendingDetail
      })
    },
    checkValue (data) {
      const totalReceivedQuantity = data.total_received_quantity
      const limitQuantityToBeSent = data.limit_quantity_to_be_sent
      const quantityToSend = data.quantity_to_send

      if (quantityToSend > (totalReceivedQuantity - limitQuantityToBeSent)) {
        data.quantity_to_send = (totalReceivedQuantity - limitQuantityToBeSent)
      }

      let checked = 0
      this.receptions.map((reception) => {
        if (reception.quantity_to_send !== null && reception.quantity_to_send > 0 && reception.quantity_to_send !== '') {
          checked += parseFloat(reception.quantity_to_send)
        }
      })
      checked > 0 ? this.touched = false : this.touched = true
    }
  }
}
</script>

<style lang="scss" scoped>

.card__wrapper {
  background-color: #026481;
  padding: 20px;
  border-radius: 0.5em;
  .title__wrapper {
    .title {
      font-size: 16px;
      color: #fff;
    }
  }

  .information__wrapper {
    .information {
      font-size: 20px;
      font-weight: bold;
      color: #fff;
    }
  }
}

.input__wrapper,
.actions__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.gutters {
  padding: 10px;
}

.ml-2 {
  margin-left: 20px;
}
</style>
